import { render, staticRenderFns } from "./tur-pop-content.vue?vue&type=template&id=65aa2241&scoped=true"
import script from "./tur-pop-content.vue?vue&type=script&lang=js"
export * from "./tur-pop-content.vue?vue&type=script&lang=js"
import style0 from "./tur-pop-content.vue?vue&type=style&index=0&id=65aa2241&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa2241",
  null
  
)

export default component.exports